import { Token } from '@primer/react';
import styled from 'styled-components';

export const AddButton: typeof Token = styled(Token)`
  cursor: pointer;
  align-self: flex-start;
  height: 30px;
  padding-top: var(--space__xs);
  padding-bottom: var(--space__xs);
  background-color: transparent;
  border-radius: var(--border-radius__md);
  font-weight: 500;
  /*color: var(--fgColor-muted);*/
  color: var(--platform-gray-400);
  border: 1px dashed var(--color__gray-200);

  &:hover {
    background-color: var(--color__gray-200);
  }
`;

export const ListToken: typeof Token = styled(Token)`
  height: 30px;
  font-weight: 500;
  background-color: var(--color__blue-100);
  padding-top: var(--space__xs);
  padding-bottom: var(--space__xs);
  border-radius: var(--border-radius__md);
`;
